import { DateFilterType } from "../../types/types";
import { Action } from "../types";

const initialState: DateFilterType = {
    startDateForAttribute: '',
    endDateForAttribute: '',
    isInitialised:false
  };
  
  export function DateFilterReducer(
    state: DateFilterType = initialState,
    action: Action<any>) {
    switch (action.type) {
      case 'SET_START_DATE_FOR_ATTRIBUTE':
            return {
                startDateForAttribute:action.payload,
            };
      case 'SET_END_DATE_FOR_ATTRIBUTE':
        return {
            endDateForAttribute:action.payload,
        };
        case 'IS_INITIALISED':
        return {
            isInitialised:action.payload,
        };
      default:
        return state;
    }
  };